export default "__VITE_ASSET__2a1e52ea__"